import { useApiRequestHelper } from '@/composables/useApiRequestHelper.js'
import { defineStore } from 'pinia'
import { computed, inject, ref } from 'vue'

export const useSiteStore = defineStore(
  'site',
  () => {
    const { $apiAuthenticatedRequest, apiUrlAuthenticated } = useApiRequestHelper()
    const axios = inject('$axios')

    const site = ref({})

    const getSiteGeoFencing = computed(() => {
      return 'site_map_properties' in site.value
        ? site.value.site_map_properties?.filter(
            (property) => property.type === 'Feature' && property.geometry.type === 'Polygon',
          )
        : []
    })

    const fetchSite = async (siteId, includes = [], filters = {}) => {
      return await $apiAuthenticatedRequest
        .get(
          'maintainable-entities',
          $apiAuthenticatedRequest.configs.get
            .setId(siteId)
            .setIncludes(includes)
            .setFilters(filters),
        )
        .then(({ data }) => {
          site.value = data
        })
    }

    const validateAccessCode = async (siteId, accessCode) => {
      try {
        await axios.post(`${apiUrlAuthenticated.value}/site/${siteId}/access-code`, {
          access_code: accessCode,
        })

        return true
      } catch (error) {
        return false
      }
    }

    const reset = () => {
      site.value = {}
    }

    return {
      site,
      getSiteGeoFencing,
      fetchSite,
      validateAccessCode,
      reset,
    }
  },
  { persist: true },
)
